/**
 * Caixa alta nos campos de digitação.
 *
 * Padrão da casa, decidido pelo Richard em 14/08/2026: **dado identificável é
 * gravado em MAIÚSCULAS**, mesmo quando digitado em minúsculas. Assim um
 * cliente nunca aparece escrito de dois jeitos.
 *
 * Esta função é a comodidade da tela. **A garantia mora no servidor**
 * (`api/src/lib/texto.ts`): se algum caminho aqui escapar, o banco corrige.
 *
 * NÃO use em e-mail, endereço de site, senha nem texto longo — ver o porquê
 * no arquivo do servidor.
 */
export function maiuscula(valor: string): string {
  return valor.toLocaleUpperCase('pt-BR');
}
